module.exports = __webpack_public_path__ + "static/media/logo.eb9d5dcb.png";


//////////////////
// WEBPACK FOOTER
// ./src/Images/logo.png
// module id = 541
// module chunks = 0